// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"68":"4f70947b","350":"da841942"}[chunkId] + ".css";
};